<template>
  <Dialog v-model="isOpen" title="关于" width="80vw">
    <div class="dialog-com">
      <div v-for="(v, k) in showObj" :key="k" class="msg-item">
        <div class="key">{{ k }}</div>
        <div v-if="!v.includes('http')" class="val">{{ v }}</div>
        <a
          v-else
          :href="v"
          target="_blank"
          :style="{ color: appConfig.colors[1] }"
        >
          {{ v }}
        </a>
      </div>
      <div class="img-box">
        <img :src="`${appConfig.domainName}/files/xiToolsXcx.jpg`" alt="" />
        <div class="img-name">微信小程序版</div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { ref, computed, watch, onBeforeMount, onMounted } from "vue";
import Dialog from "@/components/Dialog.vue";
let appConfig = require("@/config/appConfig.json");

let isOpen = ref(false);
let showObj = ref({});

watch(isOpen, (val) => {
  if (val) {
    setShowObj();
  }
});

let close = () => {
  isOpen.value = false;
};

let open = () => {
  isOpen.value = true;
};

let setShowObj = () => {
  showObj.value = {
    应用名称: appConfig.appName,
    应用版本: appConfig.appVersion,
    作者: appConfig.author,
    描述: appConfig.description,
    博客: appConfig.blog,
  };
};

//暴露方法
defineExpose({ open, close });
</script>

<style scoped lang="scss">
.dialog-com {
  display: flex;
  flex-direction: column;
  .img-box {
    margin: 2rem auto;
    display: flex;
    flex-direction: column;
    img {
      height: 10rem;
      width: 10rem;
      border-radius: 50%;
    }
    .img-name {
      text-align: center;
      font-weight: bolder;
      font-size: 1.4rem;
    }
  }
}
</style>
